module.exports = __webpack_public_path__ + "img/char_001.4868fbca.png";